import React from "react";
import { apolloClient } from "../..";
import { notify } from "../Notify/Notify";
import SavedViews from "./SavedViews/SavedViews";
import SaveIcon from "../../assets/icons/save.svg";
import ChevronIcon from "../../assets/icons/down-chevron.svg";

// Styles
import "./SavedViewsContainer.scss";
import { ADD_SAVED_VIEWS_QUERY, EDIT_SAVED_VIEWS_QUERY } from "./SavedViews/Queries";
import AddSavedView from "./AddSavedView/AddSavedView";

const SavedViewsContainer = ({ handleSavedViewsApply, selectedColumns, folderId }) => {
  const [showListDropdown, setShowListDropdown] = React.useState(false);
  const [showAddDropdown, setShowAddDropdown] = React.useState(false);
  const [selectedView, setSelectedView] = React.useState(null);

  const savedViewsRef = React.createRef();

  React.useEffect(() => {
    // Set saved views close handler
    const handleClickOutsideOfSavedViews = (event) => {
      if (savedViewsRef && savedViewsRef.current && !savedViewsRef.current.contains(event.target)) {
        setShowListDropdown(false);
        setShowAddDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideOfSavedViews);

    // Remove listener when no need
    return () => {
      window.removeEventListener("mousedown", handleClickOutsideOfSavedViews);
    };
  }, [savedViewsRef]);

  const saveView = (selectedView, isAdd = false) => {
    if (!isAdd && !selectedView) {
      setShowAddDropdown(true);
      setShowListDropdown(false);
      return;
    }

    let variables = {
      // Just to remove "files" from the array
      columns: selectedColumns.slice(1),
      title: selectedView.title,
    };

    if (isAdd) {
      variables = { ...variables, folderId: folderId };
    } else {
      variables = { ...variables, savedViewId: selectedView.id };
    }

    apolloClient
      .mutate({
        mutation: isAdd ? ADD_SAVED_VIEWS_QUERY : EDIT_SAVED_VIEWS_QUERY,
        variables: variables,
      })
      .then((result) => {
        const { success, savedView } = isAdd ? result.data.saveSavedViews : result.data.editSavedViews;
        if (success) {
          setShowListDropdown(false);
          setShowAddDropdown(false);

          // Update the selected view to reflect in the list
          setSelectedView({ ...savedView, columns: JSON.parse(savedView.columns) });

          const detail = "Success";
          const title = `View ${isAdd ? `Added` : `Updated`} successfully`;
          const type = "success";
          notify(detail, title, type);
        }
      })
      .catch((e) => {
        const title = "Error";
        const detail = e.message ?? "oops! Something went wrong";
        const type = "error";
        notify(title, detail, type);
      });
  };

  const handleSavedViewSelect = (selectedView) => {
    setSelectedView(selectedView);
    if(selectedView) {
      handleSavedViewsApply(selectedView.columns);
    }
  };

  return (
    <div className="saved-views-container mr-3 " ref={savedViewsRef}>
      <div className="saved-views-container-save">
        <img src={SaveIcon} alt="Saved views icon" width="24" height="24" onClick={() => saveView(selectedView)} />
      </div>
      <div className="saved-views-container-dropdown">
        <img
          src={ChevronIcon}
          alt="Saved views dropdown"
          width="18"
          height="18"
          onClick={() => {
            setShowListDropdown((state) => !state);
            setShowAddDropdown(false);
          }}
        />
      </div>
      <div style={{ display: showListDropdown ? "block" : "none" }}>
        <SavedViews
          {...{
            setShowAddDropdown,
            setShowListDropdown,
            handleSavedViewSelect,
            selectedView,
          }}
        />
      </div>

      <div style={{ display: showAddDropdown ? "block" : "none" }}>
        <AddSavedView
          {...{
            showAddDropdown,
            setShowAddDropdown,
            saveView,
          }}
        />
      </div>
    </div>
  );
};

export default SavedViewsContainer;
